import { addOrganisationUrl, deleteOrganisationDataUrl,getAllOrganisationDataUrl, getOrganisationUrl, apiToken } from "../config";

// add organisationData call

export const addOrganisationData = async (data,{ setIsLoading}) => {
    try {
      setIsLoading(true);
      const response = await fetch(addOrganisationUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiToken}`
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const res = await response.json();
      return res;
    } catch(e) {

      throw new Error("Network response was not ok")
  
    } finally {
      setIsLoading(false);
    }
  }
  // add organisationData call ended
  
  // to get all existing organisation data
  
  export const getAllOrganisationData = async ({setIsLoading}) => {
    try {
      setIsLoading(true);
      const response = await fetch(getAllOrganisationDataUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiToken}`
        }
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = response.json();
      return data;
      
    } catch(e) {
      throw new Error('Failed to fetch data');
    } finally {
      setIsLoading(false);
    }
  }
  
  
  // to get all existing organisation data ended
  
  // to delete a particular organisation
  
  export const deleteData = async (organisationId) => {
    const url = deleteOrganisationDataUrl.concat(organisationId);

    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        });

        const data = await response.json(); 

        if (!response.ok) {
            throw new Error(data?.message || 'Failed to delete organisation.');
        }

        return data; 

    } catch (error) {
        throw new Error(error.message || 'Unexpected error occurred.');
    }
};
  
  // to delete a particular organisation ended
  
  // to get organisation details with id 
  
  export const getOrganisationDataWithId = async (id) => {
    try {
      const url = getOrganisationUrl + id;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiToken}`
        }
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json(); 
      return data;
    } catch (e) {
      console.error('Failed to fetch organization:', e);
      throw e;
    }
  };
  
  
  // to get organisation details with id  ended
  
  // update organisation with id PUT req
  export const updateOrganisationWithId = async (id, data) => {
    try {
  
      const url = getOrganisationUrl.concat(id);
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiToken}`
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
       const responseJson = await response.json();
       return responseJson;
    } catch(e) {
      console.error(e)
    } 
  }
  
  // update organisation with id PUT req ended